import { PlinkoRisk, PlinkoRows } from '@/components/games/plinko-v2/types'
import generateFloat from '../generateFloat'

export type CalculatePlinkoBetResultOptions = {
  serverSeed: string
  clientSeed: string
  nonce: number
  risk: PlinkoRisk
  rows: PlinkoRows
}

export default function calculatePlinkoBetResult(
  options: CalculatePlinkoBetResultOptions
) {
  const { serverSeed, clientSeed, nonce, risk, rows } = options

  let payoutIndex = 0

  for (let i = 0; i < rows; i++) {
    const float = generateFloat({ serverSeed, clientSeed, nonce, round: i })
    payoutIndex += Math.floor(float * 2)
  }

  return payoutIndex
}
